// The api has some outdated terminology, so what is important here
// is actually the numbers on the enum. The "API Term" refers to
// what the value is named in the api enum
export enum AssessmentType {
  PeerEndorsement = 0, // API Term: Technical
  Questionnaire = 1, // API Term: Behavioral
  FieldsOfPractice = 2, // API Term: CareerPath
}

export enum AssessmentTypeDescription {
  PeerEndorsement = 'Peer',
  Questionnaire = 'Questionnaire',
  FieldsOfPractice = 'Fields of Practice',
}

export enum AssessmentSubType {
  RatingAssessment = 0,
  GroupAssessment = 1,
  QuestionnaireAssessment = 2,
  FOPAssessment = 3,
}

export enum AssessmentSubTypeDescription {
  RatingAssessment = 'Rating Assessment',
  GroupAssessment = 'Group Assessment',
  QuestionnaireAssessment = 'Questionnaire Assessment',
  FOPAssessment = 'Fields of Practice Assessment',
}

